import { useCallback, useState, useEffect } from "react";
import PageTitle from "../utils/PageTitle";
import { catchError } from "../../services/DaoService";
import { Button, Card, Spin } from "antd";
import { PlusCircleFilled, ReloadOutlined } from "@ant-design/icons";
import { EtapeModeleService } from "../../services/EtapeModeleService";
import EtapeModeleCreateForm from "./EtapeModeleCreateForm";
import EtapeModeleList from "./EtapeModeleList";
import PropTypes from "prop-types";

export default function EtapeModeleByModeleList({ modele }) {
	const [loading, setLoading] = useState(true);
	const [newModalVisible, setNewModalVisible] = useState(false);
	const [etapeModeles, setEtapeModeles] = useState([]);

	const init = useCallback(() => {
		setLoading(true);
		EtapeModeleService.getInstance()
			.search({ searchText: "", statut: "tout", modele_id: modele.id })
			.then((response) => {
				setEtapeModeles(response.data);
			})
			.catch((error) => {
				catchError(error);
			})
			.finally(() => {
				setLoading(false);
			});
	}, [modele]);

	useEffect(() => {
		init();
	}, [init]);

	const handleCreation = () => {
		init();
	};

	return (
		<>
			<PageTitle
				title='Etapes du modèle'
				subTitle='Gestion des étapes du modèle'
				icon={<PlusCircleFilled />}
			>
					<Button
						type='primary'
						icon={<PlusCircleFilled />}
						onClick={() => setNewModalVisible(true)}
					>
						Associer des étapes
					</Button>
				<Button type='default' icon={<ReloadOutlined />} onClick={init}>
					Rafraîchir
				</Button>
			</PageTitle>
			<Card>
				<Spin spinning={loading}>
					<EtapeModeleList
						etapeModeles={etapeModeles}
						setEtapeModeles={setEtapeModeles}
					/>
				</Spin>
			</Card>

			<EtapeModeleCreateForm
				visible={newModalVisible}
				onCreate={handleCreation}
				onCancel={() => setNewModalVisible(false)}
				etapeModeles={etapeModeles}
				modele_id={modele.id}
			/>
		</>
	);
}

EtapeModeleByModeleList.propTypes = {
	modele: PropTypes.object.isRequired,
};
